import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3C492F",
  "fill-rule": "evenodd",
  d: "M15.059.808a6.036 6.036 0 0 1 6.038 5.986v4.53a6.037 6.037 0 0 1-6.039 6.038 6.037 6.037 0 0 1-6.038-6.039V6.794A6.036 6.036 0 0 1 15.059.808m.754 5.989h3.775a4.53 4.53 0 0 0-3.775-4.409zm-1.51-4.409v4.409H10.53a4.53 4.53 0 0 1 3.774-4.409m.755 13.464c2.499 0 4.53-2.03 4.53-4.529v-3.02H10.53v3.02c0 2.499 2.03 4.53 4.53 4.53",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3C492F",
  d: "M16.258 28.82a1 1 0 0 1-1.642 0l-2.15-3.092a1 1 0 0 1 .822-1.57h4.298a1 1 0 0 1 .82 1.57z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }